import { computed, ref, watch } from "@vue/composition-api";
import { useChatbot } from "@/composables/chatbot";
import { useChatbotFake } from "@/composables/chatbotFake";
import store from "@/store";

export function useDefineChatbot() {

    const typeChat = ref('real')
    const chatbot = useChatbot()
    const chatbotFake = useChatbotFake()
    const viewHasSidebar = computed(() => store.getters["chatbot/getViewHasSidenav"]);
    const chat = computed(() => typeChat.value === 'fake' ? store.getters["chatbotFake/getChat"] : store.getters["chatbot/getChat"]);
    const isLoadingResponse = computed(() => store.getters["chatbot/getLoadingStatus"]);
    const myMessage = ref({
        from: 'me',
        completed: true,
        body: '',
        type: 'text'
    })
    const currentStep = chatbotFake.currentStep
    const showReadyBtn = chatbotFake.showReadyBtn
    const canBeMaximized = computed(() => store.state.chatbot.canBeMaximized);
    const functions = {
        fake: {
            messageHandler: chatbotFake.messageHandler,
            onDrag: chatbotFake.onDrag,
            onScroll: chatbotFake.onScroll,
            goToBottom: chatbotFake.goToBottom,
            setFilter: chatbotFake.setFilter,
        },
        real: {
            messageHandler: chatbot.messageHandler,
            onDrag: chatbot.onDrag,
            onScroll: chatbot.onScroll,
            goToBottom: chatbot.goToBottom,
        }
    }

    const useFunction = (funcName, ...args)=> {
        if (functions[typeChat.value][funcName]) {
            return functions[typeChat.value][funcName](...args);
        } else {
            throw new Error(`Function '${funcName}' does not exist.`);
        }
    }

    const closeChat = ()=> {
        chatbot.closeChat(typeChat.value)
        store.commit("chatbot/closeChatbotHelp");
        reloadChatbot()
    }

    const messageHandler = ()=> {
        if(isLoadingResponse.value) return;
        const message = myMessage.value.body.replace(/[\n\r]/g, '');
        // if (message === 'modo super admin') {
        //         typeChat.value = 'real'
        //         chatbotFake.reloadChat()
        // }

        // if (message=== 'salir modo super admin') {
        //         typeChat.value = 'fake'
        //         chatbot.reloadChat()
        // }
        useFunction('messageHandler', message)
        myMessage.value.body = ''
    }

    const onScroll = ()=> {
        chatbot.onScroll()
    }

    const goToBottom = ()=> {
        chatbot.goToBottom()
    }

    const continueSteps = (option, hasFilters, isMessageCompleted)=> {
        chatbotFake.continueSteps(option, hasFilters, isMessageCompleted)
    }

    const onDrag = (args)=> {
        useFunction('onDrag', args)
    }

    const setFilter = (code, index, value, isMessageCompleted)=> {
        useFunction('setFilter', code, index, value, isMessageCompleted)
    }

    const setFinalProcess = ()=> {
        chatbotFake.setFinalProcess()
    }

    const reloadChatbot = ()=> {
        store.commit("chatbot/updateLoadinStatus", false);
        chatbotFake.reloadChat()
        chatbot.reloadChat()
    }

    const minimizeChatbot = ()=> {
        store.commit("chatbot/updateMinimize", true);
        store.commit("chatbot/closeChatbotHelp");
        store.commit("chatbot/closeChatBot");
        store.commit("chatbot/updateMessagesToAlreadyShown");
    }

    const maximizeChatbot = ()=> {
        if (!canBeMaximized.value) return;
        goToBottom()
        store.commit("chatbot/updateMinimize", false);
        store.commit("chatbot/openChatBot");
    }

  return {
    closeChat,
    messageHandler,
    viewHasSidebar,
    onScroll,
    goToBottom,
    chat,
    myMessage,
    continueSteps,
    onDrag,
    setFilter,
    setFinalProcess,
    currentStep,
    showReadyBtn,
    reloadChatbot,
    typeChat,
    minimizeChatbot,
    maximizeChatbot
  }
}